export const PROJECT_STATUSES = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  COMPLETED: 'COMPLETED',
};

export const ENTRY_STATUSES = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const TASK_STATUSES = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
};

export const ENTRY_TYPES = {
  MANUAL: 'MANUAL',
  TIMER: 'TIMER',
};

export const CURRENCIES = {
  RSD: 'rsd',
  EUR: 'eur',
  USD: 'usd',
};

export const PROJECT_COLORS = [
  '#1890ff',
  '#52c41a',
  '#faad14',
  '#f5222d',
  '#722ed1',
  '#13c2c2',
  '#eb2f96',
  '#fa8c16',
  '#a0d911',
  '#2f54eb',
];

export const STATUS_COLORS = {
  DRAFT: 'default',
  SUBMITTED: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  ACTIVE: 'success',
  ARCHIVED: 'warning',
  COMPLETED: 'processing',
  OPEN: 'default',
  IN_PROGRESS: 'processing',
  DONE: 'success',
};

export const MEMBER_ROLES = {
  MEMBER: 'member',
  LEAD: 'lead',
};

export const MEMBER_DEFAULT_PARAMS = Object.freeze({
  offset: '1',
  limit: '10',
  employee: undefined,
  sector: undefined,
  role: undefined,
  sortEmployee: undefined,
  sortSector: undefined,
  sortRole: undefined,
  sortHourlyRate: undefined,
});

export const MEMBER_COLUMNS_DEFAULT_PARAMS = Object.freeze({
  employee: undefined,
  sector: undefined,
  role: undefined,
});

export const TASK_DEFAULT_PARAMS = Object.freeze({
  offset: '1',
  limit: '10',
  name: undefined,
  status: undefined,
  sortName: undefined,
  sortStatus: undefined,
  sortEstimatedHours: undefined,
});

export const TASK_COLUMNS_DEFAULT_PARAMS = Object.freeze({
  name: undefined,
  status: undefined,
});
